import React from 'react';
import Textinput from './textinput';

import { isEveryValid, isEmailValid, isLengthValid } from '../services/utils';

class ManageMarketPopup extends React.Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.clearForm = this.clearForm.bind(this);

        this.initialState = {
            name: '',
            email_group: '',
            validation: {
                name: false,
                email_group: false
            },
            submitCliked: false
        }

        this.state = this.initialState;
        this.fetched = false;
    }

    componentWillReceiveProps(nextProps) {       
        if (nextProps != this.props)
            this.fillForm(nextProps);
    }

    fillForm(props) {              
        if (props.params && props.params.data && !this.fetched) {
            if ('data' in props.params) this.fetched = true;         
            this.setState({
                name: (props.params.mode=='update') ? props.params.data.name : '',
                email_group: props.params.data.email_group ? props.params.data.email_group : '',
                validation: {
                    name: !!props.params.data.name,
                    email_group: !!props.params.data.email_group
                }
            });          
        }
    }

    handleChange(e) {
        const name = e.target.name;
        const value = e.target.value;

        let stateProps ={
            [name]: value
        };

        this.setState(stateProps, () => { this.validateField(name, value) });
    }

    validateField(fieldName, value) {
        if (this.state.validation[fieldName] != undefined) {
            if (fieldName=='email_group') {
                value = isEmailValid(value);
            } else {
                value = isLengthValid(value, fieldName);
            }
            this.setState({
                validation: {
                    ...this.state.validation,
                    [fieldName]: value ? true : false
                }
            });
        }
    }

    handleSubmit(mode, state, data) {
        let isValid = isEveryValid(state.validation);

        this.setState({
            ...state,
            submitCliked: true,
        });

        const updates = { ...data, ...state, email: state.email_group };

        const id = mode === 'update' ? { id: updates.id } : {};
        const marketData = {
            ...id,
            name: updates.name,
            email_group: updates.email_group,
        };

        if (isValid) {
            this.props.manageMarket(mode, marketData, this.clearForm);
        }
    }

    closePopup(e) {
        if (e.target.getAttribute('name') == 'manageMarketPopup') {
            this.props.hidePopup();          
            this.clearForm();
        }
    }

    clearForm() {
        this.setState(this.initialState);
        this.fetched = false;
    }

	render() {
        let { mode, name, data } = this.props.params;
        let { submitCliked } = this.state;

        return (
            <div
                onClick={ this.closePopup.bind(this) }
                style={{display: this.props.visible ? 'block' : 'none' }}
                name='manageMarketPopup'
                className='admin-market-container generic-popup-container'>
                  <div className='admin-market-inner'>
                      <center>
                        <h2 className='title'>
                            {mode == 'create' ? 'Create' : 'Update'} market
                        </h2>
                      </center>

                    <Textinput
                        label='Market name'
                        name='name'
                        value={ this.state.name }
                        onChange={ this.handleChange }
                        required={true}
                        invalid={!this.state.validation.name && submitCliked}
                        type='text' />

                    <Textinput
                        label='Email'
                        name='email_group'
                        value={ this.state.email_group }
                        onChange={ this.handleChange }
                        required={true}
                        invalid={!this.state.validation.email_group && submitCliked}
                        type='text' />

                      <button
                        onClick={this.handleSubmit.bind(this, mode, this.state, data)}
                        className='button button-block'>
                        {mode == 'create' ? 'Create' : 'Update'}
                      </button>
                  </div>
            </div>
        )
    }
}

export default ManageMarketPopup;



// WEBPACK FOOTER //
// ./source/components/manageMarketPopup.js